import { useDecision } from '@optimizely/react-sdk';

import { FeatureFlags, UxFeaturesVariables } from '@frontend/constants/featureFlags';

export function useUxFeatures() {
  const [decision] = useDecision(FeatureFlags.UX_FEATURES);
  const vars = decision?.variables;

  return {
    reorgRagContext: Boolean(vars?.[UxFeaturesVariables.REORG_RAG_CONTEXT]),
    exportSpecializedAgentsLogs: Boolean(
      vars?.[UxFeaturesVariables.EXPORT_SPECIALIZED_AGENTS_LOGS]
    ),
  };
}
